import '../../../core/styles/virtualFocus.css';
import '../../../core/components/app-root/AppRoot.css';
import '../FilterField.css';
import '../suggestions/SuggestionsOverlay.css';
import '../suggestions/Suggestion.css';
import './FilterStatement.css';
export var escapeCharacter = '_ia7amm4-3-5-0';
export var highlight = '_ia7amm5-3-5-0';
export var highlighting = {syntax:'_ia7amm0-3-5-0',minimal:'_ia7amm1-3-5-0'};
export var root = '_ia7amm2-3-5-0 _96tj13c-3-5-0';
export var statement = '_ia7amm3-3-5-0';
export var whitespace = '_ia7amm6-3-5-0';